import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAward = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 9a6 6 0 1 0 12 0a6 6 0 1 0 -12 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 15l3.4 5.89l1.598 -3.233l3.598 .232l-3.4 -5.889" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.802 12l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889" })
	]
});
export { SvgAward as ReactComponent };
